// Dependencies
import styled from "styled-components";

// Utils
import { theme } from "config/theme";

export const Container = styled.div`
    display: block;
    margin: auto;
    justify-content: center;
    width: 258px;

    .content-calendars {
        margin: auto;
        display: block;
        justify-content: center;
    }

    .flatpicker-wrapper {
        width: 100% !important;
    }

    .flatpicker {
        width: 100% !important;
        display: flex !important;
        flex-direction: row !important;
        gap: 8px !important;
        margin-bottom: 8px !important;
    }

    .input {
        height: 40px;
        width: 100%;
        padding: 10px 16px;

        background: ${theme.colors.white};
        border: 1px solid ${theme.colors.base[200]};
        box-sizing: border-box;
        border-radius: 4px;

        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-size: 0.875rem;
        font-weight: 400;

        letter-spacing: 0;
        line-height: 1.428;

        color: ${theme.colors.base[400]};
        cursor: default;

        textarea:focus,
        &:focus {
            border: 1px solid rgb(156, 159, 176);
            box-shadow: 0 0 0 0;
            outline: 1px solid ${theme.colors.system.info[200]};
        }
    }

    .label {
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-size: 0.75rem;
        font-weight: 400;

        letter-spacing: 0.01em;
        line-height: 1.333;
        color: ${theme.colors.base[400]};
        margin-bottom: 2px;
    }

    .flatpickr-calendar {
        box-shadow: none !important;
    }

    .flatpickr-calendar,
    .flatpickr-rContainer,
    .flatpickr-days {
        width: 100% !important;
    }

    .flatpickr-rContainer {
        gap: 0 !important;
    }

    .flatpickr-day {
        width: 32px !important;
        height: 32px !important;
        line-height: 30px !important;
        font-size: 0.75rem !important;
        padding: 0 !important;
        margin-top: 1px !important;
    }

    .flatpickr-day.today {
        border-color: #959ea9 !important;

        &:hover {
            background: #959ea9 !important;
            color: ${theme.colors.white} !important;
        }
    }

    .flatpickr-day.flatpickr-disabled {
        color: rgba(57, 57, 57, 0.1) !important;
    }

    .rangeMode .flatpickr-day {
        margin-top: 1px !important;
    }

    .numInputWrapper {
        font-family: "Nunito", sans-serif !important;
        font-style: normal !important;
        font-size: 10px !important;
        font-weight: 400 !important;
        width: 6ch !important;

        letter-spacing: 0 !important;
        line-height: 1.428 !important;
    }

    .flatpickr-months {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 8px !important;
        border-bottom: 1px solid ${theme.colors.base[100]} !important;
        width: 100% !important;
        margin: auto !important;
        margin-bottom: 13px !important;

        .flatpickr-next-month {
            right: 0 !important;
            top: 0 !important;

            &:hover {
                background-color: transparent !important;
            }
        }

        .flatpickr-prev-month {
            left: 0 !important;
            top: 0 !important;

            &:hover {
                background-color: transparent !important;
            }
        }
    }

    .flatpickr-current-month,
    .flatpickr-weekdays {
        font-family: "Nunito", sans-serif !important;
        font-style: normal !important;
        font-size: 1rem !important;
        font-weight: 600 !important;

        letter-spacing: 0 !important;
        line-height: 1.375 !important;

        text-align: center !important;

        text-transform: uppercase !important;
    }

    .flatpickr-current-month span.cur-month {
        color: ${theme.colors.brand[300]} !important;
    }

    .flatpickr-current-month input.cur-year {
        color: ${theme.colors.base[300]} !important;
        font-size: inherit !important;
        font-weight: 300;
        line-height: inherit;
        padding-left: 3px !important;
    }

    span.flatpickr-weekday {
        color: rgba(0, 0, 0, 0.54) !important;
        display: flex !important;
        justify-content: center !important;
        font-size: 0.75rem !important;
        font-weight: 900 !important;
    }

    .flatpickr-innerContainer {
        border-bottom: transparent !important;
    }

    .dayContainer {
        font-family: "Nunito", sans-serif !important;
        font-style: normal !important;
        font-size: 0.75rem !important;
        font-weight: 700 !important;

        letter-spacing: 0 !important;
        line-height: 1.333 !important;
        text-align: center !important;
        color: ${theme.colors.base[400]} !important;
        min-width: 256px !important;
        max-width: 300px !important;
        flex: 1 !important;
        min-width: unset !important;

        span {
            width: auto !important;
            height: auto !important;
        }
    }

    .selected {
        background: ${theme.colors.brand[300]} !important;
        border-color: ${theme.colors.brand[300]} !important;

        &:active,
        &:hover {
            background: ${theme.colors.brand[300]} !important;
            background-color: ${theme.colors.brand[300]} !important;
            border-color: ${theme.colors.brand[300]} !important;
        }
    }

    .inRange {
        background-color: ${theme.colors.brand[100]} !important;
        box-shadow: ${theme.colors.brand[100]} -5px 0px 0px, ${theme.colors.brand[100]} 5px 0px 0px !important;
        border-color: ${theme.colors.brand[100]} !important;
        &:active,
        &:hover {
            background-color: ${theme.colors.brand[100]} !important;
        }
    }

    .startRange,
    .endRange {
        color: ${theme.colors.white} !important;
        background: ${theme.colors.brand[300]} !important;
        border-color: ${theme.colors.brand[300]} !important;

        &:active,
        &:hover {
            background: ${theme.colors.brand[300]} !important;
            background-color: ${theme.colors.brand[300]} !important;
            border-color: ${theme.colors.brand[300]} !important;
            font-weight: 700 !important;
        }
    }

    .wrapper-alert {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        margin: 24px auto 0;
        max-width: 256px;

        .content-alert {
            margin-bottom: 16px;
            text-align: center;
        }

        .img {
            margin-bottom: 8px;
        }

        .text {
            font-family: "Nunito", sans-serif;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 16px;
            letter-spacing: 0.01em;
            text-align: center;
        }
    }

    @media (min-width: 768px) {
        width: 100%;
        max-width: 600px;
        justify-content: space-between;

        .content-calendars {
            display: flex;
            border-bottom: 1px solid ${theme.colors.base[100]};
        }

        .finalInput {
            display: block;
        }

        .label-input {
            width: 100%;
        }

        .flatpicker {
            display: flex;
            flex-direction: inherit;
            height: 58px;
        }

        .dayContainer {
            min-width: 50%;
        }

        .divider {
            border: 1px solid ${theme.colors.base[100]};
            height: 100%;
            display: flex;
            margin: auto 4px;
        }

        .wrapper-alert {
            max-width: 600px;
            flex-direction: inherit;

            .content-alert {
                display: flex;
                margin-bottom: 0;
                align-items: center;
            }

            .img {
                margin-bottom: 0;
                margin-right: 8px;
            }

            .text {
                text-align: left;
                width: 191px;
            }
        }
    }
`;

export const ButtonWrapper = styled.div`
    margin-left: auto;
`;
